import _classCallCheck from "/home/shgbit/space365-apps/default/universal/space/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/shgbit/space365-apps/default/universal/space/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { builtinModules } from 'module';

var debug = require('debug')('shgbit:app:config');
/**
	* 获取配置项
	* 
  * 基本配置项:
	* 1. 单点登录服务: AUTH_ORIGIN
	* 2. 后台接口服务: BACKEND_ORIGIN
	* 
	* 策略：
	* 1. [编译时配置] 根据window.location.hostname给出配置
	* 	a. apps.space365.net 表示云端
	* 	b. localhost 表示本地开发
	* 2. [运行时配置] 根据window.RUNTIME_CONFIG可在index.html后期覆盖编译时配置
	*		a. 用来应对编译后无法识别的hostname，包括私有化部署等情况需要手动加入config.js
	* 
	* 导入:
	* 1. import config from 'share/common/config'
	* 2. const config = require('./config').default;
	*
	* @class
	*/


var Config =
/*#__PURE__*/
function () {
  function Config() {
    _classCallCheck(this, Config);

    var hostname = window.location.hostname;
    this.items = {};

    if (/localhost/i.test(hostname)) {
      this.items['auth_origin'] = 'http://localhost:9000';
      this.items['backend_origin'] = 'http://localhost:9000';
      this.items['home_origin'] = 'http://localhost:3000';
    } else if (/space\.io/i.test(hostname)) {
      // for localhost test
      this.items['auth_origin'] = 'http://localhost:9000';
      this.items['backend_origin'] = 'http://localhost:9000';
      this.items['home_origin'] = 'http://localhost:3000';
    } else if (/apps\.space365\.[net|live]/i.test(hostname)) {
      this.items['auth_origin'] = 'https://id.space365.net';
      this.items['backend_origin'] = 'https://api.space365.net';
      this.items['home_origin'] = 'https://apps.space365.net';
    } else if (/booking\.geely\.com/i.test(hostname)) {
      this.items['auth_origin'] = 'http://booking.geely.com/api';
      this.items['backend_origin'] = 'http://booking.geely.com/api';
      this.items['home_origin'] = 'http://booking.geely.com';
    } else {
      this.items['auth_origin'] = "http://".concat(hostname, ":9000");
      this.items['backend_origin'] = "http://".concat(hostname, ":9000");
      this.items['home_origin'] = "http://".concat(hostname, ":3000");
    }

    if (window.RUNTIME_CONFIG) {
      if (window.RUNTIME_CONFIG.AUTH_ORIGIN) {
        this.items['auth_origin'] = window.RUNTIME_CONFIG.AUTH_ORIGIN;
      }

      if (window.RUNTIME_CONFIG.BACKEND_ORIGIN) {
        this.items['backend_origin'] = window.RUNTIME_CONFIG.BACKEND_ORIGIN;
      }
    }
  }

  _createClass(Config, [{
    key: "get",
    value: function get(key) {
      return this.items[key];
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this.items[key] = value; // 直接连接云端后台 (only for localhost)

      if (/[localhost|space\.io]/i.test(location.hostname) && key === 'devWithCloudEnv' && value) {
        this.items['auth_origin'] = 'https://id.space365.net';
        this.items['backend_origin'] = 'https://api.space365.net';
        this.items['home_origin'] = 'https://apps.space365.net';
      }
    }
  }, {
    key: "getAuthOrigin",
    value: function getAuthOrigin() {
      return this.get('auth_origin');
    }
  }, {
    key: "getBackendOrigin",
    value: function getBackendOrigin() {
      return this.get('backend_origin');
    }
  }, {
    key: "getHomeOrigin",
    value: function getHomeOrigin() {
      return this.get('home_origin');
    }
  }]);

  return Config;
}();

var config = new Config();
export default config;